// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.laptop-hero-container {
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 56.74%;
  height: 0;
}

.laptop-hero-screen {
  position: absolute;
  left: 10.24%;
  top: 2.47%;
  width: 79.52%;
  height: 85.41%;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
  z-index: 1000;
}

.laptop-hero-frame {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 10;
}
.laptop-hero-frame img {
  display: block;
  width: 100%;
  height: 100%;
}

.laptop-hero-screen-wallpaper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}
.laptop-hero-screen-wallpaper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.laptop-hero-app-window {
  position: absolute;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  border-radius: 13px;
  border: 0.5px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.25), 0 2px 10px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  z-index: 1000;
}

.laptop-hero-window-header {
  padding: 4px 8px;
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
  color: var(--theme-text-secondary, rgba(0, 0, 0, 0.6));
  background: rgba(0, 0, 0, 0.02);
  background: var(--window-header-bg, rgba(0, 0, 0, 0.02));
  min-height: 28px;
  -webkit-user-select: none;
          user-select: none;
}

.laptop-hero-window-title {
  flex: 1 1;
  pointer-events: none;
}

.laptop-hero-window-content {
  flex: 1 1;
  background: #fff;
  padding: 16px;
  overflow: hidden;
}

.laptop-hero-window-placeholder {
  width: 100%;
  height: 100%;
}

.laptop-hero-placeholder-line {
  height: 3px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-bottom: 8px;
}
.laptop-hero-placeholder-line.short {
  width: 60%;
}

.laptop-hero-browser-bar {
  height: 24px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  margin-bottom: 12px;
}

.laptop-hero-ai-chat-panel {
  position: absolute;
  right: 3%;
  top: 15%;
  width: 28%;
  height: 65%;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  border-radius: 13px;
  border: 0.5px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.25), 0 2px 10px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  z-index: 1000;
}

.laptop-hero-chat-header {
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(245, 245, 245, 0.8);
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  font-size: 11px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
}

.laptop-hero-chat-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  color: white;
}

.laptop-hero-chat-title {
  flex: 1 1;
}

.laptop-hero-chat-messages {
  flex: 1 1;
  padding: 12px;
  background: #fff;
  overflow: hidden;
}

.laptop-hero-chat-message {
  display: flex;
  margin-bottom: 8px;
}

.laptop-hero-message-bubble {
  background: rgba(0, 0, 0, 0.05);
  padding: 8px 12px;
  border-radius: 12px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.8);
  max-width: 80%;
}

.laptop-hero-chat-input {
  padding: 10px 12px;
  background: #fff;
  border-top: 0.5px solid rgba(0, 0, 0, 0.1);
}

.laptop-hero-input-placeholder {
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.4);
}

.orb-umbilical-wrapper {
  position: relative;
  width: 100vw;
  left: 50%;
  transform: translateX(-50%);
  height: 1100px;
  margin-top: -4px;
  pointer-events: none;
}

.orb-umbilical-orb {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

@media (max-width: 968px) {
  .laptop-hero-container {
    width: 100%;
  }
  .laptop-hero-app-window,
  .laptop-hero-ai-chat-panel {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/marketing/products/PersonalAIPage/LaptopHero.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;AACF;AACE;EACE,cAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,4CAAA;EACA,2EACE;EAEF,gBAAA;EACA,aAAA;AAHF;;AAMA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EAAA,sDAAA;EACA,+BAAA;EAAA,wDAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AAHF;;AAMA;EACE,SAAA;EACA,oBAAA;AAHF;;AAMA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;AAHF;;AAMA;EACE,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAKE;EACE,UAAA;AAHJ;;AAOA;EACE,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,4CAAA;EACA,2EACE;EAEF,gBAAA;EACA,aAAA;AANF;;AASA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oCAAA;EACA,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AANF;;AASA;EACE,SAAA;AANF;;AASA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,kBAAA;AANF;;AASA;EACE,+BAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AANF;;AASA;EACE,kBAAA;EACA,gBAAA;EACA,0CAAA;AANF;;AASA;EACE,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AANF;;AAWA;EAEE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;AATF;;AAYA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AATF;;AAcA;EACE;IACE,WAAA;EAXF;EAcA;;IAEE,aAAA;EAZF;AACF","sourcesContent":[".laptop-hero-container {\n  position: relative;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding-bottom: 56.74%; // 1237 / 2180 * 100\n  height: 0;\n}\n\n.laptop-hero-screen {\n  position: absolute;\n  left: 10.24%;\n  top: 2.47%;\n  width: 79.52%;\n  height: 85.41%;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #000;\n  z-index: 1000;\n}\n\n.laptop-hero-frame {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  z-index: 10;\n  \n  img {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.laptop-hero-screen-wallpaper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n  \n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n}\n\n.laptop-hero-app-window {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 13px;\n  border: 0.5px solid rgba(255, 255, 255, 0.3);\n  box-shadow: \n    0 10px 28px rgba(0, 0, 0, 0.25),\n    0 2px 10px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n  z-index: 1000;\n}\n\n.laptop-hero-window-header {\n  padding: 4px 8px;\n  display: flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--theme-text-secondary, rgba(0, 0, 0, 0.6));\n  background: var(--window-header-bg, rgba(0, 0, 0, 0.02));\n  min-height: 28px;\n  user-select: none;\n}\n\n.laptop-hero-window-title {\n  flex: 1;\n  pointer-events: none;\n}\n\n.laptop-hero-window-content {\n  flex: 1;\n  background: #fff;\n  padding: 16px;\n  overflow: hidden;\n}\n\n.laptop-hero-window-placeholder {\n  width: 100%;\n  height: 100%;\n}\n\n.laptop-hero-placeholder-line {\n  height: 3px;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 2px;\n  margin-bottom: 8px;\n  \n  &.short {\n    width: 60%;\n  }\n}\n\n.laptop-hero-browser-bar {\n  height: 24px;\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 6px;\n  margin-bottom: 12px;\n}\n\n.laptop-hero-ai-chat-panel {\n  position: absolute;\n  right: 3%;\n  top: 15%;\n  width: 28%;\n  height: 65%;\n  display: flex;\n  flex-direction: column;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 13px;\n  border: 0.5px solid rgba(255, 255, 255, 0.3);\n  box-shadow: \n    0 10px 28px rgba(0, 0, 0, 0.25),\n    0 2px 10px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n  z-index: 1000;\n}\n\n.laptop-hero-chat-header {\n  padding: 10px 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(245, 245, 245, 0.8);\n  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);\n  font-size: 11px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.laptop-hero-chat-avatar {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9px;\n  font-weight: 700;\n  color: white;\n}\n\n.laptop-hero-chat-title {\n  flex: 1;\n}\n\n.laptop-hero-chat-messages {\n  flex: 1;\n  padding: 12px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.laptop-hero-chat-message {\n  display: flex;\n  margin-bottom: 8px;\n}\n\n.laptop-hero-message-bubble {\n  background: rgba(0, 0, 0, 0.05);\n  padding: 8px 12px;\n  border-radius: 12px;\n  font-size: 11px;\n  color: rgba(0, 0, 0, 0.8);\n  max-width: 80%;\n}\n\n.laptop-hero-chat-input {\n  padding: 10px 12px;\n  background: #fff;\n  border-top: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n\n.laptop-hero-input-placeholder {\n  padding: 8px 12px;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 8px;\n  font-size: 11px;\n  color: rgba(0, 0, 0, 0.4);\n}\n\n// ── Orb + umbilical cord ────────────────────────────────────────────────────\n\n.orb-umbilical-wrapper {\n  // Full-bleed breakout from parent max-width container\n  position: relative;\n  width: 100vw;\n  left: 50%;\n  transform: translateX(-50%);\n  height: 1100px;\n  margin-top: -4px;\n  pointer-events: none;\n}\n\n.orb-umbilical-orb {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n// ── Responsive ───────────────────────────────────────────────────────────────\n\n@media (max-width: 968px) {\n  .laptop-hero-container {\n    width: 100%;\n  }\n  \n  .laptop-hero-app-window,\n  .laptop-hero-ai-chat-panel {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
